/* ==========================================================================
   HN Samples — het juiste gratis sample in de mand, door het thema zelf
   (14 okt 2026; instellingen in de groep "HN Samples", brug in
   snippets/hn-samples.liquid, verhaal in docs/04-winkelmand-notes.md)

   WAAROM DIT IN HET THEMA ZIT EN NIET IN DE APP
   De regel die de eigenaar wil is "wasmiddel én gel in de mand → geen
   sample". Kite kan dat niet: die kent wel "koop X, krijg Y", maar niet
   "krijg niets zodra je allebei hebt". Daarom neemt het thema het uitdelen
   over. Er is geen korting voor nodig — de samples kosten 0,00 — dus dit
   script doet niets anders dan een regel toevoegen of weghalen.

   DE REGELS
   Vóór de startdatum (fase 1): elke mand met minstens één gewoon product
   krijgt het wasmiddelsample.
   Vanaf de startdatum (fase 2):
     geen wasmiddel in de mand      -> wasmiddelsample
     wel wasmiddel, geen gel        -> gelsample
     wasmiddel én gel               -> geen sample
   Geen bedragdrempel. Altijd hoogstens één sample, aantal 1. Een lege mand,
   of een mand waar alleen een sample in ligt, krijgt niets.

   WAT ER ALS "HET SAMPLE" GELDT
   Elke regel met de variant van een van de twee samples — ook eentje die de
   Kite-app heeft neergelegd. Zo komt er nooit een tweede bij: wat er al ligt
   wordt herkend, en hooguit vervangen.

   WAT ER ALS WASMIDDEL OF GEL TELT
   De producten uit de twee triggerlijsten, op product-id, dus elke variant
   telt. Ook regels die als onderdeel van een bundel in de mand komen: die
   dragen hun eigen product-id, en een regel met losse onderdelen
   (item_components) wordt op die onderdelen nagekeken.

   GEEN LUSSEN
   Er loopt er hooguit één tegelijk (`bezig`), en elk verzoek dat dit script
   zelf doet gaat via de eigenFetch van de mandbewaker — die zet de vlag die
   zegt "dit ben ik zelf", zodat de wijziging het script niet opnieuw aanzet.
   Komt er tijdens een ronde tóch een wijziging binnen, dan wordt er precies
   één extra ronde ingepland, niet een stapel.

   STIL BIJ TEGENSLAG
   Een sample dat uitverkocht is, niet bestaat of niet toegevoegd kan worden
   levert geen melding in beeld op — de klant heeft er niets aan en is niets
   kwijt. Het staat wél in de console, met het waarom.
   ========================================================================== */

(function () {
  'use strict';

  var C = window.HNSamples;
  var MERK = '[HN Samples]';

  if (!C) return;
  if (!C.aan) return;

  var bezig = false;
  var nogEenRonde = false;

  function meld() {
    if (!window.console || !console.info) return;
    var stukken = Array.prototype.slice.call(arguments);
    stukken.unshift(MERK);
    console.info.apply(console, stukken);
  }

  var bewaker = window.HNMandbewaker || null;
  var haal = (bewaker && bewaker.eigenFetch) ? bewaker.eigenFetch : function (u, o) { return fetch(u, o); };

  /* DE NEDERLANDSE TIJD ZELF UITREKENEN.
     De instelling is "JJJJ-MM-DD UU:MM" in Europe/Amsterdam. JavaScript kent
     geen "lees deze muurklok in die tijdzone", dus: lees hem eerst als UTC,
     kijk daarna welke muurklok Amsterdam op dát moment aanwijst, en corrigeer
     met het verschil. Dat verschil ís de offset (zomertijd of wintertijd) van
     dat moment, dus dit klopt ook over de klokwissel heen. Alleen het uur dat
     bij de wissel wordt overgeslagen of herhaald is dubbelzinnig; daar valt
     niets aan te doen en het maakt voor een startdatum om middernacht niet
     uit. */
  function amsterdamNaarTijdstip(tekst) {
    var m = /^\s*(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(String(tekst || ''));
    if (!m) return null;
    var alsUtc = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    try {
      var vorm = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Amsterdam', hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
      });
      var d = {};
      vorm.formatToParts(new Date(alsUtc)).forEach(function (deel) { d[deel.type] = deel.value; });
      var muurklok = Date.UTC(+d.year, +d.month - 1, +d.day, (+d.hour) % 24, +d.minute);
      return alsUtc - (muurklok - alsUtc);
    } catch (e) {
      /* Geen Intl: dan maar op UTC. Hooguit twee uur verschil op één moment
         in de tijd, en dat is beter dan helemaal niet starten. */
      return alsUtc;
    }
  }

  function inFase2() {
    if (!C.start) return true;
    var t = amsterdamNaarTijdstip(C.start);
    if (t === null) {
      meld('startdatum "' + C.start + '" is niet te lezen (verwacht JJJJ-MM-DD UU:MM); fase 1 aangehouden');
      return false;
    }
    return Date.now() >= t;
  }

  function sampleVarianten() {
    var uit = [];
    ['wasmiddel', 'gel'].forEach(function (soort) {
      var s = C.samples && C.samples[soort];
      if (s && s.variantId) uit.push(Number(s.variantId));
    });
    return uit;
  }

  function isSampleRegel(regel) {
    return sampleVarianten().indexOf(Number(regel.variant_id)) !== -1;
  }

  /* Een bundel komt soms als één regel met onderdelen binnen. De onderdelen
     dragen hun eigen product-id, dus die tellen net zo goed mee als een losse
     regel — anders zou "wasmiddel in een bundel" niet als wasmiddel gelden. */
  function productIdsVanRegel(regel) {
    var ids = [Number(regel.product_id)];
    var onderdelen = regel.item_components || regel.components;
    if (onderdelen && onderdelen.length) {
      onderdelen.forEach(function (o) { if (o && o.product_id) ids.push(Number(o.product_id)); });
    }
    return ids;
  }

  function staatIn(lijst, regel) {
    if (!lijst || !lijst.length) return false;
    var ids = productIdsVanRegel(regel);
    for (var i = 0; i < lijst.length; i += 1) {
      if (ids.indexOf(Number(lijst[i])) !== -1) return true;
    }
    return false;
  }

  /* Welk sample hoort er bij deze mand? null = geen. */
  function bepaalSoort(mand) {
    var gewoon = mand.items.filter(function (r) { return !isSampleRegel(r); });
    if (!gewoon.length) return null;
    if (!inFase2()) return 'wasmiddel';

    var heeftWasmiddel = gewoon.some(function (r) { return staatIn(C.triggers.wasmiddel, r); });
    var heeftGel = gewoon.some(function (r) { return staatIn(C.triggers.gel, r); });

    if (!heeftWasmiddel) return 'wasmiddel';
    if (!heeftGel) return 'gel';
    return null;
  }

  function sectieLading() {
    var lading = {};
    try {
      var helper = window.Alpine && window.Alpine.store ? window.Alpine.store('xCartHelper') : null;
      if (helper && typeof helper.getSectionsToRender === 'function') {
        lading.sections = helper.getSectionsToRender().map(function (s) { return s.id; });
        lading.sections_url = window.location.pathname;
      }
    } catch (e) { /* Alpine nog niet geladen */ }
    return lading;
  }

  function wegMet(regel) {
    var lading = sectieLading();
    lading.id = regel.key;
    lading.quantity = 0;
    return haal('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(lading),
    }).then(function (r) { return r.json(); });
  }

  /* METEEN MÉT DE EIGENSCHAPPEN NEERLEGGEN, NOOIT ACHTERAF OPPLAKKEN.
     `_free_gift` is de tak waar de Liquid van Kite op kijkt (die verbergt de
     aantalkiezer), `_hn_sample` is waar het label "Gratis sample" aan hangt en
     waaraan te zien is dat deze regel van ons komt. Achteraf een eigenschap op
     een bestaande regel zetten geeft hem een andere regelsleutel; dat leverde
     op 14 okt een dubbel cadeau op. */
  function legNeer(soort) {
    var s = C.samples[soort];
    var lading = sectieLading();
    lading.items = [{
      id: Number(s.variantId),
      quantity: 1,
      properties: { _free_gift: 'true', _hn_sample: soort },
    }];
    return haal('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(lading),
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (t) {
          /* Uitverkocht of niet toe te voegen: stil overslaan. De klant merkt
             er niets van en mist alleen iets wat hij toch niet had. */
          meld('sample "' + soort + '" kon niet toegevoegd worden (' + r.status + '): ' + t.slice(0, 160));
          return null;
        });
      }
      return r.json();
    });
  }

  function vernieuw(antwoord) {
    if (bewaker && typeof bewaker.herrender === 'function') { bewaker.herrender(antwoord); return; }
    if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
  }

  function ronde() {
    return haal('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (mand) {
        if (!mand || !mand.items) return null;

        var gewenst = bepaalSoort(mand);
        var gewensteVariant = gewenst ? Number(C.samples[gewenst].variantId) : null;
        if (gewenst && !gewensteVariant) {
          meld('sample "' + gewenst + '" heeft geen variant in de instellingen; overgeslagen');
          return null;
        }
        if (gewenst && C.samples[gewenst].beschikbaar === false) {
          meld('sample "' + gewenst + '" staat als niet beschikbaar in de instellingen; overgeslagen');
          gewenst = null;
          gewensteVariant = null;
        }

        var aanwezig = mand.items.filter(isSampleRegel);
        var juist = aanwezig.filter(function (r) { return Number(r.variant_id) === gewensteVariant; });
        var teveel = aanwezig.filter(function (r) { return Number(r.variant_id) !== gewensteVariant; });
        /* Meer dan één regel van het goede sample: houd de eerste, de rest weg. */
        teveel = teveel.concat(juist.slice(1));

        if (!teveel.length && (!gewenst || juist.length)) return null;

        meld('mand: ' + mand.items.length + ' regel(s); gewenst sample: ' + (gewenst || 'geen')
          + '; weghalen: ' + teveel.length + '; toevoegen: ' + (gewenst && !juist.length ? 'ja' : 'nee'));

        /* Eén voor één, niet tegelijk: twee gelijktijdige mandverzoeken geven
           bij Shopify een 429 of een halve mand terug. */
        var keten = Promise.resolve(null);
        teveel.forEach(function (regel) {
          keten = keten.then(function () { return wegMet(regel); });
        });
        if (gewenst && !juist.length) {
          keten = keten.then(function () { return legNeer(gewenst); });
        }
        return keten;
      })
      .catch(function (e) {
        meld('ronde afgebroken: ' + (e && e.message ? e.message : e));
        return null;
      });
  }

  function verwerk() {
    if (bezig) { nogEenRonde = true; return; }
    bezig = true;
    ronde().then(function (antwoord) {
      bezig = false;
      if (antwoord) vernieuw(antwoord);
      if (nogEenRonde) { nogEenRonde = false; verwerk(); }
    });
  }

  /* Niet bij elke pagina een mandverzoek erbij als de mand toch leeg is — en
     een lege mand krijgt per definitie geen sample. De teller in de header is
     server-side gevuld, dus die is hier al te lezen. */
  function verwerkAlsErIetsInDeMandZit() {
    var teller = document.querySelector('#cart-icon-bubble span');
    if (teller && String(teller.textContent).trim() === '0') return;
    verwerk();
  }

  if (bewaker && typeof bewaker.opMandwijziging === 'function') {
    bewaker.opMandwijziging(verwerk);
  } else {
    meld('de mandbewaker is er niet; dit script reageert dan alleen op paginaladingen');
  }

  /* Wachten tot Alpine er is, om dezelfde reden als de mandbewaker: anders
     kunnen de sectie-id's niet mee en wordt de mandpagina herladen in plaats
     van hertekend. */
  function startZodraHetKan(pogingen) {
    var klaar = false;
    try {
      klaar = !!(window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper'));
    } catch (e) { klaar = false; }
    if (klaar || pogingen >= 20) { verwerkAlsErIetsInDeMandZit(); return; }
    setTimeout(function () { startZodraHetKan(pogingen + 1); }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { startZodraHetKan(0); });
  } else {
    startZodraHetKan(0);
  }
})();
